$(function() {
    "use strict";

    // Sticky tags pane
    var $tags = $('.tag-filter__active-tags');

    // Only if tags exist and not a touch device
    if ( $tags.length ) {

        var sidebarClass = 'tag-filter_sidebar',
            stickedClass = 'tag-filter__sticked-section',
            $sidebar = $('.'+sidebarClass),
            $header = $('.header');

        $(window).on('scroll.tag-filter_sidebar', function() {
            if ( $(window).scrollTop() + $header.outerHeight(true) > $sidebar.offset().top ) {
                $tags
                    .css({
                        'top': $header.outerHeight(true) - 1
                    })
                    .addClass(stickedClass)
                    .parent('.'+sidebarClass)
                    .css('padding-top', $tags.outerHeight(true));
            }
            else {
                $tags
                    .css({
                        'top': ''
                    })
                    .removeClass(stickedClass)
                    .parent('.'+sidebarClass)
                    .css('padding-top', 8);
            }
        });
    }
});
